import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { normalizeUserRole } from '@/utils/roles';

interface UserState {
  role: string | null;
  username: string | null;
  first_name: string | null;
  last_name: string | null;
  user_id: string | null;
}

const initialState: UserState = {
  role: null,
  username: null,
  first_name: null,
  last_name: null,
  user_id: null,
};

/** Map legacy Cognito/JWT roles onto the consolidated Role enum. */
const toStoredRole = (role: string): string => normalizeUserRole(role) ?? role;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserRole: (state, action: PayloadAction<string>) => {
      state.role = toStoredRole(action.payload);
    },
    setUsername: (state, action: PayloadAction<string>) => {
      state.username = action.payload;
    },
    setFirstName: (state, action: PayloadAction<string>) => {
      state.first_name = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.last_name = action.payload;
    },
    setUserId: (state, action: PayloadAction<string>) => {
      state.user_id = action.payload;
    },
    setUserProfile: (
      state,
      action: PayloadAction<{
        username?: string;
        role?: string;
        first_name?: string;
        last_name?: string;
        user_id?: string;
      }>
    ) => {
      const { username, role: incomingRole, first_name, last_name, user_id } = action.payload;
      if (username !== undefined) state.username = username;
      if (incomingRole !== undefined) state.role = toStoredRole(incomingRole);
      if (first_name !== undefined) state.first_name = first_name;
      if (last_name !== undefined) state.last_name = last_name;
      if (user_id !== undefined) state.user_id = user_id;
    },
    clearUser: (state) => {
      state.role = null;
      state.username = null;
      state.first_name = null;
      state.last_name = null;
      state.user_id = null;
    },
  },
});

export const {
  setUserRole,
  setUsername,
  setFirstName,
  setLastName,
  setUserId,
  setUserProfile,
  clearUser,
} = userSlice.actions;
export default userSlice.reducer;
